import React, { Component, Fragment } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";

export default class OrderSaveCfm extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      showDialog,
      onCancel,
      onOk,
      orderInfor
    } = this.props
    let strConfirm = "Thực hiện lưu đơn hàng cho "
    if (orderInfor.bo_chiet_khau) {
      strConfirm += "khách kí hợp đồng"
    } else {
      strConfirm += "khách lẻ"
    }
    return (
      <div className="animated fadeIn">
        <Modal isOpen={showDialog} className="modal-md" modalClassName={"order-approve-cfm"}>
          <ModalHeader>Xác nhận lưu đơn hàng?</ModalHeader>
          <ModalBody>
            <div className="col-sm-12 mb-2 pl-0">
              <span className="text-left">{strConfirm}</span>
              <span className="text-danger pl-1">[{orderInfor.ten_khach_hang}]</span>
            </div>
            <div className="clearfix"></div>
            <div className="col-sm-12">
              <div className="btn-group float-right" role="group">
                <Button className="btn btn-success mr-1" onClick={() => onOk()}>
                  <i className="fa fa-check"></i><span className="d-none d-sm-inline">&nbsp;Đồng ý</span></Button>
                <Button className="btn btn-danger" onClick={() => onCancel()}>
                  <i className="fa fa-close"></i><span className="d-none d-sm-inline">&nbsp;Hủy</span></Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/Order/_OrderSaveCfm.js